import React, { FC, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Accept, FileRejection } from "react-dropzone";
import {
  ActionTypeEnum,
  CompanySettingModel,
  HasFormIdModel,
  RowStateEnum,
  SystemModulesEnum,
  ValidationErrorModel,
} from "../../models";
import {
  getLabelName,
  getUserId,
  handleError,
  setFormikFieldValueByName,
} from "../../utils";
import { Card, Col, Form, Row } from "react-bootstrap";
import {
  ButtonBox,
  EntityUploader,
  ErrorValidationBox,
  LoadingBox,
  PrivilegesChecker,
  TextBox,
} from "..";
import { saveCompanySetting } from "../../serviceBroker/companySettingApiServiceBroker";
import { useSystemConfigurations } from "../../hooks";

interface CompanySettingDetailsProps extends HasFormIdModel {
  request?: CompanySettingModel | null;
  onActionEvent?: any | null;
}

export const CompanySettingDetails: FC<CompanySettingDetailsProps> = ({
  request,
  formId,
  onActionEvent = () => {},
}) => {
  //#region variables
  const allowedMimeTypes: string[] = ["image/png", "image/jpg", "image/jpeg"];
  const acceptTypes: Accept = { allowedMimeTypes };
  const initialValues: CompanySettingModel = request ?? {
    FormatDecimal: "",
    DefaultCurrency_ID: 0,
    Currency_ID: 0,
    CurrencyShortCut: "",
    IsTrialVersion: false,
    SoftwareName: undefined,
    Advert: undefined,
    PrintItemPrescriptionOfTransaction: false,
    BacckGroundImage: "",
    LogoImage: "",
    BackColor: 0,
    BackGroundImageName: "",
    LogoImageName: "",
    Phone: "",
    Mail: "",
    Password: "",
    DateType: false,
    TextLogo: "",
    ValueOfPoint: 0,
    SendMailOfSalesOnClose: false,
    RecivedMail: "",
    Header: undefined,
    DecimalPlace: 0,
    PathBackUp: "",
    UserNameSMS: "",
    PasswordSMS: "",
    MobileReceiver: "",
    SendSMS: false,
    SenderName: "",
    SetScaleOnPrice: false,
    SetScaleWeightonKG: false,
    UseOldModelForSearch: false,
    DefaultTaxPercentage: 0,
    ApplyTax: false,
    TaxNumber: "",
    HideItemFromCloseDay: false,
    MaxQuantity: 0,
    TransferTaxToDiscount: false,
    ShowItemPriceWithoutTax: false,
    PrintItemArabicEngInBill: false,
    Company_Address: "",
    CalcDiscountWithVAT: false,
    SetCostPriceZeroOnSalePriceZero: false,
    Is_Company_Authorized_Tobacco: false,
    WaterMarkImage: "",
    ServiceUI: "",
    IsUploadTransactionToCloud: false,
    Printer_Tablet_List: "",
    SystemSettings: "",
    IncludeVatOnEditPrice: false,
    DaysOfDeleteBackupFiles: 0,
    IsCodeTransactionSeparated: false,
    CompanyAddress: "",
    IsSentEmailReportAfterCloseDayOnly: false,
    CompanySetting_UniqueId: "",
    TermsAndCondations: "",
    IsFloorSecondeCurrency: false,
    CheckBalanceOfItemOnAdd: false,
    LogoImage64: "",
    ValueOfCurrency: 0,
    FormatDate: "",
    ArabicLanguage: "",
    EnglishLanguage: "",
    voucherSettings: undefined,
    AttachmentFolder: undefined,
    IsUploadShipmentTrackToCloud: false,
    Token: undefined,
    IsEnableToUploadEinvoice: false,
    ID: 0,
    CreatedBy: undefined,
    ModifiedBy: undefined,
    Name: "",
    CreationDate: "",
    ModificationDate: "",
    VerifyOnUpdate: false,
    Errors: [],
    rowState: 0,
    isInitialRequest: true,
  };
  const validationSchema = Yup.object({
    Name: Yup.string().required(getLabelName("Company Name.missing")),
    DecimalPlace: Yup.number()
      .positive(getLabelName("mustpositive"))
      .integer(getLabelName("mustintegar")),
    Password: Yup.string().required(),
    Mail: Yup.string().email(getLabelName("validemail")),
    //RecivedMail: Yup.string().email(getLabelName("validemail")),
    MaxQuantity: Yup.number()
      .positive(getLabelName("mustpositive"))
      .integer(getLabelName("mustintegar")),
    DefaultTaxPercentage: Yup.number()
      .positive(getLabelName("mustpositive"))
      .integer(getLabelName("mustintegar")),
  });

  //#endregion
  //#region state
  const [loading, setLoading] = useState(false);
  const systemConfig = useSystemConfigurations(setLoading);
  const isPOCEnabled =
    systemConfig.userConfiguration?.systemModulesConfigurations?.find(
      (id) => id.ID == SystemModulesEnum.Shared_POS_and_Restaurant
    )?.Enable;
  const [validationErrors, setValidationErrors] = useState<
    ValidationErrorModel[]
  >([]);
  const [logoImage, setLogoImage] = useState<string | null>(null);
  //#endregion
  //#region function
  const handleBlurOnAllFields = () => {
    Object.keys(formik.initialValues).forEach((field) => {
      formik.setFieldTouched(field, true, true);
    });
  };
  const handleFormSubmit = async (values:CompanySettingModel) => {
    handleBlurOnAllFields();
    console.log("Form Values:", values);
    console.log("Validation Errors:", formik.errors);
    console.log("Touched Fields:", formik.touched);
    if (Object.keys(formik.errors).length > 0) {
      alert("Please fix validation errors before submitting.");
      return;
    }
    await handleSubmit(values);
  };
  const handleFileDrop = async (files: File[]) => {
    setLoading(true);
    try {
      if (files != null && files.length !== 0) {
        files.map((file) => {
          // acceptedFiles.push(file);
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            // @ts-ignore
            let _logoImage: string = reader.result || "";
            _logoImage = _logoImage.replace(/^data:image\/[a-z]+;base64,/, "");
            // @ts-ignore
            setLogoImage(_logoImage);
            setFormikFieldValueByName(formik, "LogoImage64", _logoImage);
          };
          reader.onabort = () => console.log("file reading was aborted");
          reader.onerror = () => console.log("file reading has failed");
          setLoading(false);
        });
      }
    } catch (err) {
      alert(handleError(err));
      setLoading(false);
    } finally {
    }
  };
  const handleFileReject = (files: FileRejection[]) => {
    files.map(async (file) => {
      alert(
        `${file.file.name} ${file.errors[0].code}  ${file.errors[0].message}`
      );
    });
  };
  const handleSubmit = async (data: CompanySettingModel) => {
    try {
      setLoading(true);
      data.rowState =
        data.ID == null || data.ID == 0
          ? RowStateEnum.Add
          : RowStateEnum.Update;
      data.CreatedBy =
        data.ID == null || data.ID == 0 ? getUserId() : data.CreatedBy;
      data.ModifiedBy =
        data.ID != null && data.ID != 0 ? getUserId() : data.ModifiedBy;
      data.LogoImageName = "";
      if (logoImage != null) {
        data.LogoImage = logoImage;
      }

      const res = await saveCompanySetting(data);
      if (res != null && res.Errors != null && res.Errors.length !== 0) {
        setValidationErrors(res.Errors);
        setLoading(false);
      } else {
        setValidationErrors([]);
        setLoading(false);
        onActionEvent({ action: ActionTypeEnum.CompanySettingDetails });
      }
    } catch (err: any) {
      setLoading(false);
      const errors: ValidationErrorModel[] = [
        { MessageAr: err, MessageEn: err },
      ];
      setValidationErrors(errors);
    }
  };
  //#endregion
  //#region formik
  const formik = useFormik({
    initialValues: {
      ...initialValues,
      DefaultTaxPercentage: initialValues.DefaultTaxPercentage ?? 0,
      IsSentEmailReportAfterCloseDayOnly:
        initialValues.IsSentEmailReportAfterCloseDayOnly ?? false,
      SetScaleOnPrice: initialValues.SetScaleOnPrice ?? false,
      SetScaleWeightonKG: initialValues.SetScaleWeightonKG ?? false,
      PrintItemArabicEngInBill: initialValues.PrintItemArabicEngInBill ?? false,
      CalcDiscountWithVAT: initialValues.CalcDiscountWithVAT ?? false,
      IncludeVatOnEditPrice: initialValues.IncludeVatOnEditPrice ?? false,
    },
    validationSchema: validationSchema,
    // enableReinitialize: true,
    onReset: () => {},
    onSubmit: async (values) => {
      await handleSubmit(values);
    },
  });

  //#endregion
  //#region html
  return (
    <>
      {loading && <LoadingBox />}
      {<ErrorValidationBox errors={validationErrors} />}
      {/*<form onSubmit={(e) => {e.preventDefault();handleFormSubmit(formik.values);}}>*/}
        <form style={{ width: "100%" }} onSubmit={formik.handleSubmit}>
        <Card>
          <Card.Header>
            <span>{getLabelName("CompanySetting")}</span>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md={8}>
                <Row gap={4}>
                  <Col md={6} className="mb-2">
                    <TextBox
                      labelName={getLabelName("Company Name")}
                      inputName={"Name"}
                      inputValue={formik.values.Name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      errorText={formik.errors.Name}
                    />
                  </Col>
                  <Col md={6} className="mb-2">
                    <TextBox
                      labelName={getLabelName("Tax Number")}
                      inputName={"TaxNumber"}
                      errorText={formik.errors.TaxNumber}
                      inputValue={formik.values.TaxNumber}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Col>
                  <Col md={6} className="mb-2">
                    <TextBox
                      labelName={getLabelName("Mobile")}
                      inputName={"Phone"}
                      inputValue={formik.values.Phone}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      errorText={formik.errors.Phone}
                    />
                  </Col>
                  <Col md={6} className="mb-2">
                    <TextBox
                      labelName={getLabelName("Address")}
                      inputName={"CompanyAddress"}
                      errorText={formik.errors.CompanyAddress}
                      inputValue={formik.values.CompanyAddress}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={4}>
                <EntityUploader
                  acceptTypes={{
                    allowedMimeTypes: ["image/png", "image/jpg", "image/jpeg"],
                  }}
                  title={getLabelName("Drag and drop here")}
                  imgStyle={{
                    objectFit: "contain",
                  }}
                  defaultImage={`data:image/jpeg;base64,${formik.values.LogoImage64}`}
                  handleFileDrop={handleFileDrop}
                  handleFileReject={handleFileReject}
                />
              </Col>
            </Row>
            <div className="row row-cols-12 my-3">
              <TextBox
                labelName={getLabelName("Logo")}
                inputName={"TextLogo"}
                inputValue={formik.values.TextLogo}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="textarea"
                errorText={formik.errors.TextLogo}
              />
            </div>
            <div className="row row-cols-12 my-3">
              <TextBox
                labelName={getLabelName("Terms and Condations")}
                inputName={"TermsAndCondations"}
                row={5}
                errorText={formik.errors.TermsAndCondations}
                inputValue={formik.values.TermsAndCondations}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="textarea"
              />
            </div>
          </Card.Body>
          <Card.Header>
            <span>{getLabelName("SystemSetting")}</span>
          </Card.Header>
          <Card.Body>
            <Row className="mb-3">
              <Col xs={12} sm={6} className="list-group-wrapper">
                <ul className="list-group">
                  {isPOCEnabled ? (
                    <li className="list-group-item">
                      <Form.Check
                        type="checkbox"
                        onChange={formik.handleChange}
                        id="SetScaleOnPrice"
                        name="SetScaleOnPrice"
                        checked={formik.values.SetScaleOnPrice}
                        label={getLabelName(
                          "Set Scale Barcode Reading To  Price not Quntity"
                        )}
                      />
                    </li>
                  ) : null}
                  <li className="list-group-item">
                    <Form.Check
                      type="checkbox"
                      onChange={formik.handleChange}
                      id="ApplyTax"
                      name="ApplyTax"
                      checked={formik.values.ApplyTax}
                      label={getLabelName(
                        "Start Apply Tax on Sales and Purches"
                      )}
                    />
                  </li>
                  {isPOCEnabled ? (
                    <li className="list-group-item">
                      <Form.Check
                        type="checkbox"
                        onChange={formik.handleChange}
                        id="SetScaleWeightonKG"
                        name="SetScaleWeightonKG"
                        checked={formik.values.SetScaleWeightonKG}
                        label={getLabelName("Set Scale Weight on KG")}
                      />
                    </li>
                  ) : null}

                  {/* <li className="list-group-item">
                    <Form.Check
                      type="checkbox"
                      onChange={formik.handleChange}
                      id="IsSentEmailReportAfterCloseDayOnly"
                      name="IsSentEmailReportAfterCloseDayOnly"
                      checked={formik.values.IsSentEmailReportAfterCloseDayOnly}
                      label={getLabelName(
                        "Send Report Of Sales After Close Day Only"
                      )}
                    />
                  </li> */}
                  {formik.values.ApplyTax ? (
                    <li className="list-group-item">
                      <Form.Check
                        type="checkbox"
                        onChange={formik.handleChange}
                        id="IncludeVatOnEditPrice"
                        name="IncludeVatOnEditPrice"
                        checked={formik.values.IncludeVatOnEditPrice}
                        label={getLabelName("Include Vat On Edit Price")}
                      />
                    </li>
                  ) : null}
                  <li className="list-group-item">
                    <Form.Check
                      type="checkbox"
                      onChange={formik.handleChange}
                      id="HideItemFromCloseDay"
                      name="HideItemFromCloseDay"
                      checked={formik.values.HideItemFromCloseDay}
                      label={getLabelName("Remove Item From Report Close Day")}
                    />
                  </li>
                </ul>
              </Col>
              <Col xs={12} sm={6} className="list-group-wrapper">
                <ul className="list-group">
                  {isPOCEnabled ? (
                    <li className="list-group-item">
                      <Form.Check
                        type="checkbox"
                        onChange={formik.handleChange}
                        id="Is_Company_Authorized_Tobacco"
                        name="Is_Company_Authorized_Tobacco"
                        checked={formik.values.Is_Company_Authorized_Tobacco}
                        label={getLabelName(
                          "Is Company Authorized For Tobacco"
                        )}
                      />
                    </li>
                  ) : null}
                  <li className="list-group-item">
                    <Form.Check
                      type="checkbox"
                      onChange={formik.handleChange}
                      id="PrintItemArabicEngInBill"
                      name="PrintItemArabicEngInBill"
                      checked={formik.values.PrintItemArabicEngInBill}
                      label={getLabelName("Print Item Name Arabic and English")}
                    />
                  </li>
                  {formik.values.ApplyTax ? (
                    <li className="list-group-item">
                      <Form.Check
                        type="checkbox"
                        onChange={formik.handleChange}
                        id="CalcDiscountWithVAT"
                        name="CalcDiscountWithVAT"
                        checked={formik.values.CalcDiscountWithVAT}
                        label={getLabelName("Calc Discount With Vat")}
                      />
                    </li>
                  ) : null}

                  <li className="list-group-item">
                    <Form.Check
                      type="checkbox"
                      onChange={formik.handleChange}
                      id="SendMailOfSalesOnClose"
                      name="SendMailOfSalesOnClose"
                      checked={formik.values.SendMailOfSalesOnClose}
                      label={getLabelName(
                        "Send Mail With Sales on Close Application"
                      )}
                    />
                  </li>
                </ul>
              </Col>
            </Row>

            <div className="row row-cols-xxl-3 row-cols-xl-3 row-cols-lg-3 row-cols-md-1 row-cols-sm-1 row-cols-1 g-md-4 g-sm-4">
              <TextBox
                labelName={getLabelName("Decimal Place Number")}
                inputName={"DecimalPlace"}
                errorText={formik.errors.DecimalPlace}
                inputValue={formik.values.DecimalPlace}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="number"
              />
              {/* <TextBox
                labelName={getLabelName("CurrentPasswordText")}
                inputName={"Password"}
                errorText={formik.errors.Password}
                inputValue={formik.values.Password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="password"
              />
              <TextBox
                labelName={getLabelName("Recived Mail")}
                inputName={"RecivedMail"}
                errorText={formik.errors.RecivedMail}
                inputValue={formik.values.RecivedMail}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="text"
              /> */}
              <TextBox
                labelName={getLabelName("Sender Mail")}
                inputName={"Mail"}
                errorText={formik.errors.Mail}
                inputValue={formik.values.Mail}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="text"
              />
              <TextBox
                labelName={getLabelName("Max Quantity")}
                inputName={"MaxQuantity"}
                errorText={formik.errors.MaxQuantity}
                inputValue={formik.values.MaxQuantity}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="number"
              />
              {formik.values.ApplyTax ? (
                <TextBox
                  labelName={getLabelName("Default Tax Percentage")}
                  inputName={"DefaultTaxPercentage"}
                  errorText={formik.errors.DefaultTaxPercentage}
                  inputValue={formik.values.DefaultTaxPercentage}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  type="number"
                />
              ) : null}
            </div>
          </Card.Body>
          <Card.Footer className="d-flex justify-content-end">
            <PrivilegesChecker
              formId={formId}
              action={request?.ID ? "EnableUpdate" : "EnableSave"}
            >
              <ButtonBox
                type="submit"
                className="mx-2"
                variant="primary"
                iconType="content-save"
              >
                {getLabelName(request?.ID ? "Update" : "Save")}
              </ButtonBox>
            </PrivilegesChecker>
            <ButtonBox
              iconType="refresh"
              variant="secondary"
              type="button"
              onClick={formik.handleReset}
            >
              {getLabelName("reset")}
            </ButtonBox>
          </Card.Footer>
        </Card>
      </form>
    </>
  );
  //#endregion
};
